import styled from 'styled-components';
import { TextButton, InlineMessage, Text, Button } from '@amzn/storm-ui';

const CancelButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-0"
})(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.base);
const ContentContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-1"
})(["flex:", ";overflow-y:auto;"], ({
  $isMobile
}) => $isMobile ? 1 : undefined);
const ContentForm = /*#__PURE__*/styled.form.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-2"
})(["background:", ";padding:", ";&& > * + *{margin-block-start:16px;}"], ({
  theme
}) => theme.modal.content, ({
  theme
}) => `12px ${theme.spacing.base}`);
const ErrorMessageWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-3"
})(["flex:1;align-self:center;"]);
const SuccessMessageContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-4"
})(["background:", ";padding:", ";padding-bottom:", ";display:flex;justify-content:flex-end;flex:1;flex-direction:column;"], ({
  theme
}) => theme.modal.footer.bg, ({
  $isMobile
}) => $isMobile ? undefined : '12px 14px', ({
  $isMobile,
  $hideActions,
  $resubmitEnabled
}) => {
  if ($hideActions || !$resubmitEnabled) {
    return $isMobile ? '0px' : '12px';
  }
  return '10px';
});
const Footer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-5"
})(["background:", ";padding:", ";padding-top:", ";display:flex;justify-content:flex-end;> *{margin-inline-end:", ";}> *:last-child{margin-inline-end:0;}border-top:", ";"], ({
  theme
}) => theme.modal.footer.bg, ({
  $isMobile,
  $isSubmittedStage
}) => $isMobile && $isSubmittedStage ? undefined : '12px 14px', ({
  $isSubmittedStage
}) => $isSubmittedStage ? '0px' : '12px', ({
  theme
}) => theme.spacing.mini, ({
  $isSubmittedStage,
  theme
}) => $isSubmittedStage ? undefined : `1px solid ${theme.modal.header.borderColor}`);
const FooterButtonsContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-6"
})(["display:flex;flex-direction:row-reverse;align-self:end;"]);
const FooterSuccessContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-7"
})(["flex:1;display:flex;flex-direction:column;gap:", ";"], ({
  theme
}) => theme.spacing.small);
const FooterSuccessInlineMessage = /*#__PURE__*/styled(InlineMessage).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-8"
})(["align-self:flex-start;"]);
const Header = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-9"
})(["background:", ";border-bottom:", ";padding:", ";display:flex;justify-content:space-between;"], ({
  theme
}) => theme.modal.header.bg, ({
  $isMobileSubmittedStage,
  theme
}) => $isMobileSubmittedStage ? undefined : `thin solid ${theme.modal.header.borderColor}`, ({
  $isMobileSubmittedStage
}) => $isMobileSubmittedStage ? undefined : '12px 14px');
const HeaderText = /*#__PURE__*/styled(Text).attrs(({
  $isMobileSubmittedStage
}) => ({
  type: 'h1',
  styleAs: $isMobileSubmittedStage ? 'h5' : 'h4',
  textColor: 'base'
})).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-10"
})([""]);
const PopperWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-11"
})(["box-sizing:border-box;outline:none;width:430px;overflow:hidden;word-wrap:break-word;border:none;border-radius:", ";background-color:", ";box-shadow:", ";"], ({
  theme
}) => theme.popover.radius, ({
  theme
}) => theme.popover.bg, ({
  theme
}) => theme.popover.boxShadow);
const PromptContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-12"
})(["background:", ";background-color:", ";border-bottom:thin solid ", ";padding:", ";"], ({
  theme
}) => theme.modal.header.bg, ({
  theme
}) => theme.palette.gray[50], ({
  theme
}) => theme.modal.header.borderColor, ({
  theme
}) => `${theme.spacing.small} ${theme.spacing.base}`);
const ResubmitButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-13"
})(["align-self:flex-end;"]);
const SecondaryViewWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-14"
})(["display:flex;flex-direction:column;height:100%;"]);
const InlineWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-15"
})(["width:100%;"]);
const MobileShareButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-16"
})(["width:100%;"]);
const IntroText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-17"
})(["margin-block-start:4px;margin-block-end:12px;"]);
const DisabledSubmitButton = /*#__PURE__*/styled(Button).attrs({
  disabled: true
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-18"
})([":disabled{pointer-events:none;}"]);
const DisclaimerText = /*#__PURE__*/styled(Text).attrs({
  type: 'p',
  fontSize: 'mini',
  textColor: 'tertiary'
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1s460ds-19"
})(["padding-block-start:4px;"]);

export { ContentContainer as C, DisclaimerText as D, ErrorMessageWrapper as E, FooterSuccessInlineMessage as F, Header as H, IntroText as I, MobileShareButton as M, PopperWrapper as P, ResubmitButton as R, SuccessMessageContainer as S, ContentForm as a, Footer as b, FooterSuccessContainer as c, FooterButtonsContainer as d, CancelButton as e, DisabledSubmitButton as f, HeaderText as g, PromptContainer as h, InlineWrapper as i, SecondaryViewWrapper as j };
//# sourceMappingURL=FormLayout.styles-BzYy_4z2.js.map
